import http from "@/utils/http.js"

// 根据id查询文章信息
export function getArticleById(id) {
	return http({
		url: "/api/web/contArticle/getArticleDetail/" + id,
		method: 'GET',
	})
}

//分页查询文章信息列表
export function getArticlePage(data) {
	return http({
		url: "/api/web/contArticle/getArticlePage",
		method: "GET",
		data: data,
	})
}

//分页查询专家顾问
export function getTeacherPage(data) {
	return http({
		url: "/api/web/teacher/page",
		method: "GET",
		data: data,
	})
}

//查询全部合作单位表
export function getCooperateUnitPage(data) {
	return http({
		url: "/api/web/cooperateUnit/list",
		method: "GET",
		data: data,
	})
}
//关键字搜索
export function searchArticle(data) {
	return http({
		url: "/api/web/contArticle/searchArticle",
		method: "GET",
		data: data,
	})
}
//分页查询推荐文章
export function getReArticlePage(data) {
	return http({
		url: "/api/web/contArticle/getRecommendArticlePage",
		method: "GET",
		data: data,
	})
}